import { login, logout, getInfo } from '@/api/user'
import { getToken, setToken, removeToken } from '@/utils/auth'
import router, { resetRouter } from '@/router'
import request from '@/utils/request'

const state = {
    token: getToken(),
    token_type: "Bearer",
    token_expires_in: 0,
    userinfo: null,
    name: '',
    username: '',
    email: '',
    mobile: '',
    avatar: '',
    job_name: '',
    roles: [],
    permissions: []
};

const mutations = {
    SET_TOKEN: (state, token) => {
        state.token = token
    },
    SET_NAME: (state, name) => {
        state.name = name
    },
    SET_AVATAR: (state, avatar) => {
        state.avatar = avatar
    },
    SET_USERNAME: (state, username) => {
        state.username = username
    },
    SET_JOB_NAME: (state, job_name) => {
        state.job_name = job_name
    },
    SET_EMAIL: (state, email) => {
        state.email = email
    },
    SET_MOBILE: (state, mobile) => {
        state.mobile = mobile
    },
    SET_ROLES: (state, roles) => {
        state.roles = roles
    },
    SET_PERMISSIONS: (state, permissions) => {
        state.permissions = permissions
    }
};

const actions = {

    //用户登录
    login({ commit }, form) {
        return new Promise((resolve, reject) => {
            request.post("login", form).then(res => {
                const { data } = res;
                commit('SET_TOKEN', data.accessToken);
                setToken(data.accessToken);
                resolve(res);
            }).catch(err => {
                reject(err);
            });
        });
    },

    // get user info
    getInfo({ commit, state }) {
        return new Promise((resolve, reject) => {
            request.get("/info").then(res => {
                const { data } = res;
                const { roles, permissions, username, name, email, mobile, jobName, avatar } = data;
                state.userinfo = data;
                if (typeof roles == 'undefined' || !roles || roles.length <= 0) {
                    reject('该用户没有分配任何权限!');
                }
                commit("SET_NAME", name);
                commit("SET_AVATAR", avatar);
                commit("SET_USERNAME", username);
                commit("SET_EMAIL", email);
                commit("SET_MOBILE", mobile);
                commit("SET_JOB_NAME", jobName);
                commit("SET_ROLES", roles);
                commit("SET_PERMISSIONS", permissions);
                resolve(state.userinfo);
            }).catch(err => {
                reject(err);
            });
        });
    },

    // user logout
    logout({ commit, state, dispatch }) {
        return new Promise((resolve, reject) => {
            function doit() {
                commit('SET_TOKEN', '');
                commit('SET_ROLES', []);
                commit('SET_PERMISSIONS', []);
                removeToken();
                resetRouter();
                dispatch('tagsView/delAllViews', null, { root: true });
                setTimeout(() => {
                    state.userinfo = null;
                }, 500);
            }
            doit();
            resolve();
            // request.post("logout").then(res=>{
            //     doit();
            //     resolve(res);
            // }).catch(err=>{
            //     doit();
            //     reject(err);
            // });
        })
    },

    // remove token
    resetToken({ commit }) {
        return new Promise(resolve => {
            commit('SET_TOKEN', '');
            commit('SET_ROLES', []);
            removeToken();
            resolve()
        })
    },

    // dynamically modify permissions
    async changeRoles({ commit, dispatch }, role) {
        const token = role + '-token';

        commit('SET_TOKEN', token);
        setToken(token);

        const { roles } = await dispatch('getInfo');

        resetRouter();

        // generate accessible routes map based on roles
        const accessRoutes = await dispatch('permission/generateRoutes', roles, { root: true });
        // dynamically add accessible routes
        router.addRoutes(accessRoutes);

        // reset visited views and cached views
        dispatch('tagsView/delAllViews', null, { root: true })
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}